/**
 * Created by mqamhieh on 11/17/16.
 */
(function (app) {

    app.factory('JobDetailsBus', ["$q", "userServices", function ($q, userServices) {
        var JobDetailsBus = {};
        var jobs = {};
        var promises = {};
        var isNoPassword = {};

        JobDetailsBus.SUCCESS = 'SUCCESS';
        JobDetailsBus.SUCCESS_NO_PASSWORD = 'SUCCESS_NO_PASSWORD';
        JobDetailsBus.DRAFTED = 'DRAFTED';
        JobDetailsBus.DISCARDED = 'DISCARDED';
        JobDetailsBus.APPLIED = 'APPLIED';
        JobDetailsBus.EXPIRED = 'EXPIRED';
        JobDetailsBus.WOTC_SUCCESS = 'WOTC_SUCCESS';
        JobDetailsBus.WOTC_NOT_COMPLETED = 'WOTC_NOT_COMPLETED';
        JobDetailsBus.EEO_SUCCESS = 'EEO_SUCCESS';

        JobDetailsBus.onJobApplyFinish = function (status, appId, applyDate, jobId) {
            console.warn("Override this function", "status", status, "appId", appId, "applyDate", applyDate, "jobId", jobId);
        };

        JobDetailsBus.onJobApplyUpdate = function (status, appId, applyDate, jobId) {
            console.warn("Override this function", "status", status, "appId", appId, "applyDate", applyDate, "jobId", jobId);
        };

        var loadJobDetails = function (jobId, pjt) {
            JobApplicationAPI.getJobDetails(jobId, pjt)
                .then(function (jobDetails) {
                    var mergedData = {};
                    var position = "";

                    // Do the same job as dataMappingCallback in 'job-post' route
                    // TODO: Refactor both areas (harri.routes.conf.js and this function)
                    if (jobDetails) {
                        mergedData.data = jobDetails;
                    } else {
                        // added by @shox if job data not exists
                        hRedirect('/404');
                    }


                    var brand = jobDetails.brand || {};
                    var job = jobDetails.job || {};

                    if (job.id) {
                        window.job_brand = {};
                        window.job_brand[job.id] = brand.id;
                    }

                    if (brand.BrandMedia) {
                        for (var i in brand.BrandMedia) {
                            if (brand.BrandMedia[i].type == 'background_image') {
                                brand.cover_uuid = brand.BrandMedia[i].uuid;
                            }
                        }
                    }
                    if (brand.force_media) {
                        brand.forced_media = {};

                        for (var i in brand.force_media) {
                            brand.force_media[i].path = brand.force_media[i].path || "";
                            brand.force_media[i].brand_id = brand.force_media[i].path.split("/")[1];
                            brand.forced_media[brand.force_media[i].type] = brand.force_media[i];
                        }
                    }

                    if (brand.Location && brand.Location.length) {
                        mergedData.data.brand.BrandLocations = publicConfiguration.functions.locationFormatter(brand.Location);
                    }


                    if (brand.slug && job.Position) {
                        position = job.alias_position != undefined ? job.alias_position : job.Position.name;
                        mergedData.data.job.job_slug = publicConfiguration.functions.urlize(job.id + ' ' + position);
                    }

                    /* Get Visibily options for JPLP
                     // from util.js
                     ==============================================*/
                    mergedData.data.visibility = getVisibilityForJPLP();

                    /* Get Parameter
                     ==========================*/
                    // getParameterByName is not defined on Node.js side, only meanful in frontend
                    if (typeof(getParameterByName) !== "undefined") {
                        var utm_source = getParameterByName("utm_source");
                        mergedData.data.utm_source = utm_source.toLowerCase();
                        if (mergedData.data.utm_source == "simply") {
                            mergedData.data.utm_source = "simplyhired";
                        }

                    }

                    if (mergedData.data.brand && mergedData.data.brand.Location) {
                        var locations = mergedData.data.brand.Location;

                        for (var i in locations) {
                            var country = locations[i].Country || {};

                            if (country['code'] == 'UK') {
                                mergedData.data.currentCounrty = 'UK';
                            }
                        }
                    }

                    if (pjt && !mergedData.data.job.private_via_link_settings?.private_key) {
                        mergedData.data.job.private_via_link_settings = {
                            private_key: pjt
                        }
                    }

                    JobDetailsBus.setJobDetails(mergedData.data.job.id, {
                        job: mergedData.data.job,
                        brand: mergedData.data.brand,
                        top_parent_brand: jobDetails.top_parent_brand
                    });
                })
        };

        var setJobDataAndCallPromises = function (jobId, jobDetails) {
            jobs[jobId] = jobDetails;

            if (promises[jobId]) {
                for (var i in promises[jobId]) {
                    promises[jobId][i].resolve(jobDetails);
                }

                promises[jobId] = [];
            }
        };

        JobDetailsBus.setJobDetails = function (jobId, jobDetails) {
            if (isNaN(jobId)) {
                console.error("Invalid jobId:", jobId);
                return;
            }

            jobId = parseInt(jobId);

            jobDetails?.brand?.BrandMedia.forEach(item => {
                if (item.format === 'CAROUSEL') {
                    item.media_secondary.sort((a, b) => a.order - b.order);
                }
            });

            if (jobDetails.brand.public_services && jobDetails.brand.public_services.indexOf(userServices.SERVICES.GDPR) > -1) {
                BrandAPI.getBrandGDPRDisclaimers(jobDetails.brand.id)
                    .then(function (disclaimers) {
                        jobDetails.disclaimers = disclaimers;
                        setJobDataAndCallPromises(jobId, jobDetails);
                    });
            }
            else {
                setJobDataAndCallPromises(jobId, jobDetails);
            }
        };

        JobDetailsBus.getJob = function (jobId, pjt) {
            if (isNaN(jobId)) {
                console.error("Invalid jobId:", jobId);
                return;
            }

            jobId = parseInt(jobId);
            var defer = $q.defer();

            if (jobs[jobId]) {
                defer.resolve(jobs[jobId]);
            }
            else {
                promises[jobId] = promises[jobId] || [];
                promises[jobId].push(defer);
                loadJobDetails(jobId, pjt);
            }

            return defer.promise;
        };

        JobDetailsBus.getIsNoPassword = function (jobId) {
            return isNoPassword[jobId];
        };

        JobDetailsBus.setIsNoPassword = function (jobId, value) {
            isNoPassword[jobId] = value;
        };

        JobDetailsBus.handleJobPageScroll = () => {
            let paddingFromTop = 0;
            if ($('harri-header').length) {
                paddingFromTop += 73;
            }
            const windowScrollTop = $(window).scrollTop();

            if ($(window).width() <= 575) {
                const documentHeight = $(document).height();
                const windowHeight = $(window).height();
                const headersHeight = $('.header-bar-mobile').height();
                let maxScroll;
                if ($('.fixed-header-mobile').hasClass('active')) {
                    maxScroll = documentHeight + headersHeight - paddingFromTop;
                } else {
                    maxScroll = documentHeight - headersHeight - paddingFromTop;
                }
                if (maxScroll > windowHeight) {
                    if (windowScrollTop > 0) {
                        $('.fixed-header-mobile').addClass('active');
                        $('.job-header').removeClass('active');
                        $('.header-bar-mobile .job-arrangements-box').css('visibility', 'hidden');
                    } else {
                        $('.fixed-header-mobile').removeClass('active');
                        $('.job-header').addClass('active');
                        $('.header-bar-mobile .job-arrangements-box').css('visibility', 'visible');
                    }
                }
            } else {
                $('.fixed-header-mobile').addClass('active');
                $('.job-header').removeClass('active');
                $('.header-bar-mobile .job-arrangements-box').css('visibility', 'hidden');
            }

            if (($(window).width() <= 575) &&
                !$('.header-bar-mobile').hasClass('fixed-bar') &&
                windowScrollTop + paddingFromTop > ($('.header-bar-mobile').position() && $('.header-bar-mobile').position().top)) {
                $('.header-bar-mobile').addClass('fixed-bar');
            } else if (($(window).width() <= 575) &&
                $('.header-bar-mobile').hasClass('fixed-bar') &&
                windowScrollTop <= $('.header').height()) {
                $('.header-bar-mobile').removeClass('fixed-bar');
            }

            const reachedId = ['job_summery', 'job_description', 'job_requirements', 'job_skills'].find((id) => {
                if ($('#' + id) && $('#' + id).offset() &&
                    (windowScrollTop + 140) > $('#' + id).offset().top &&
                    (windowScrollTop + 140) < $('#' + id).offset().top + $('#' + id).height() + 45
                ) {
                    return true;
                }
            });

            if (reachedId) {
                $('.' + reachedId).siblings().removeClass('active').end().addClass('active');
            } else if (!$('.header-bar-mobile').hasClass('fixed-bar')) {
                $('.job_summery').siblings().removeClass('active').end().addClass('active')
            } else {
                $('.header-bar-mobile ul li').removeClass('active');
            }
        }

        return JobDetailsBus;
    }]);

})(angular.module('harriApp'));
